import RethrowRouteError from "./components/RethrowRouteError";

/**
 * Single catch-all data route wrapping the existing `<Routes>` tree.
 *
 * The app keeps its declarative route table inside `<App/>`; the data router is
 * only here so router data APIs that require it — notably `useBlocker`, used by
 * the property editor's unsaved-changes guard — are available. Behaviour of
 * every existing route is unchanged. Render errors are rethrown to the app's
 * `<ErrorBoundary>` instead of the router's default error screen.
 */
export function buildAppRoutes(element) {
  return [{ path: "*", element, errorElement: <RethrowRouteError /> }];
}
